import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { User } from '../../models/User';
import { PostLogin, Sevacategorty } from '../../models/PostLogin';
import { RestProvider } from '../../providers/rest/rest';
import { TabsPage } from '../tabs/tabs';

/**
 * Generated class for the ProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage implements OnInit{
userpassed:User;
user_name:string;
user_mobile:number;
user_password:string;
user_new_password:string;
regular_access:boolean = false;
special_access:boolean = false;
aradhane_access:boolean = false;
building_fund_access:boolean = false;
// user_categories:Sevacategorty[];
user_categories:any;
logindata:PostLogin;

  constructor(public navCtrl: NavController, public navParams: NavParams, private restProvider:RestProvider, private alertCtrl:AlertController) {
  }

  ngOnInit()
  {
this.userpassed = this.navParams.get('user');
console.log("this.userpassed",this.userpassed);
this.logindata = this.navParams.get('logindata');
console.log("logindata",this.logindata)
if(this.userpassed)
{
  this.user_name = this.userpassed.name;
  this.user_mobile = this.userpassed.phone;
  this.user_categories = this.logindata.svacategory;
  console.log("user_categories on profile page:",this.logindata.svacategory)
}

  }
  Cancel()
  {
    this.user_password = null;
    this.user_new_password = null;
    this.navCtrl.push(TabsPage,{user:this.logindata})
  }
  OnSaveUser()
  {
    if(this.user_password != this.user_new_password)
    {
      let alert = this.alertCtrl.create({
        title: 'Alert',
        subTitle: 'Passwords does not match',
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
              this.user_password = null;
              this.user_new_password = null;
            }
          }
        ]
      });
      alert.present();
      return;
    }
    let usrobj = new User;
    usrobj.is_reset_password = 1;
    usrobj.id = this.userpassed.id;
    usrobj.name = this.userpassed.name;
    usrobj.password = this.user_new_password;
    console.log("usrobj before passing",usrobj)
    if(this.user_password != null && this.user_new_password != null)
    {
      this.restProvider.updateUser(usrobj).subscribe((result) => {
        console.log(result);
        if(result)
        {
          let alert = this.alertCtrl.create({
            title: 'Alert',
            subTitle: 'Password changed',
            buttons: [
              {
                text: 'Ok',
                handler: () => {
                  console.log('Yes clicked');
                  this.user_password = null;
                  this.user_new_password = null;
                }
              }
            ]
          });
          alert.present();
        }
        

        // this.selectedUser();
        this.navCtrl.push(TabsPage,{user:this.logindata});
        
    
      }
     ,error => {
    console.log(error);
    let alert = this.alertCtrl.create({
      title: 'Alert',
      subTitle: 'Password not changed.Please try again',
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            console.log('Yes clicked');
            this.user_password = null;
            this.user_new_password = null;
          }
        }
      ]
    });
    alert.present();
     }
     );
    }
    else
    {
      let alert = this.alertCtrl.create({
        title: 'Alert',
        subTitle: 'Please enter the passwords before saving.',
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
              this.user_password = null;
              this.user_new_password = null;
            }
          }
        ]
      });
      alert.present();
    }
  
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts